import { Tooltip } from '@infl-ts/ui-advocate-components';
import { formatDistanceStrictShort, getLocale } from '@infl-ts/util-date';
import { useLanguage } from '@infl-ts/util-i18n-provider';
import { Typography } from '@mui/material';
import { format, parseISO } from 'date-fns';
import * as DATE from 'fp-ts/Date';
import { pipe } from 'fp-ts/function';
import * as IO from 'fp-ts/IO';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
var ONE_MINUTE = 60000;

var Timestamp = function Timestamp(_ref) {
  var timestamp = _ref.timestamp;

  var _useState = useState(DATE.create()),
      now = _useState[0],
      setNow = _useState[1];

  var _useLanguage = useLanguage(),
      currentLang = _useLanguage.currentLang;

  var locale = getLocale(currentLang);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  useEffect(function () {
    var setCurrentTimeToNow = pipe(DATE.create, IO.chain(function (x) {
      return function () {
        return setNow(x);
      };
    }));
    var intervalId = setInterval(setCurrentTimeToNow, ONE_MINUTE);
    return function () {
      return clearInterval(intervalId);
    };
  }, []);
  var parsedDate = parseISO(timestamp);
  return /*#__PURE__*/_jsx(Tooltip, {
    arrow: true,
    placement: "top",
    title: format(parsedDate, 'PPpp', {
      locale: locale
    }),
    "data-element": "Tooltip",
    "data-component": "Timestamp",
    "data-source-file": "timestamp.tsx",
    children: /*#__PURE__*/_jsx(Typography, {
      variant: "body2",
      sx: {
        color: function color(t) {
          return t.palette.text.disabled;
        },
        whiteSpace: 'nowrap'
      },
      "data-element": "Typography",
      "data-component": "Timestamp",
      "data-source-file": "timestamp.tsx",
      children: formatDistanceStrictShort(now, t, {
        locale: locale
      })(parsedDate)
    })
  });
};

export default Timestamp;